// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__YA2Ss","title":"card_title__1pFVe","inActive":"card_inActive__rAtJu"};